import ComparisonPage from './ComparisonPage';

export default function CalendlyComparisonPage() {
  return <ComparisonPage competitorKey="calendly" competitorName="Calendly" />;
}
